import React from "react";
import Contact from "../Contact";

export default function ContactoSection({ data, configuracion }) {
    const { tituloSeccion, subtituloSeccion, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'contacto';

    // El componente Contact ya tiene el formulario
    return <Contact titulo={tituloSeccion} subtitulo={subtituloSeccion} configuracion={configuracion} id={ancla} />;
}
